import React from 'react';
import {OrbitComponent} from '../../../base-components/orbit-component/orbit-component';
import {ISearchSuggestion} from '../../../../services/game-search/game-search-result';
import {HighlightSearchListItemComponent} from '../highlight-search-list-item/highlight-search-list-item.component';
import {observer} from 'mobx-react';
import {SearchResultItemBox} from "./boxes/search-result-item-box/search-result-item.box";
import {SlotsSearchLinkBox} from "./boxes/search-links/slots-search-link/slots-search-link.box";
import {LiveSearchLinkBox} from "./boxes/search-links/live-search-link/live-search-link.box";
import {CardAndTableSearchLinkBox} from "./boxes/search-links/card-and-table-search-link/card-and-table-search-link.box";
import {RegularSearchLinkBox} from "./boxes/search-links/regular-search-link/regular-search-link.box";
import {GAMES_CATEGORIES} from "../../../../services/games/games-categories.enum";

export interface SearchResultItemComponentProps {
  searchSuggestion: ISearchSuggestion
}

export const SearchResultItemComponent = observer(
  class SearchResultItemComponent extends OrbitComponent<SearchResultItemComponentProps> {

    private _onClickHandler = () => {
      this.services.gameSearch.closeSearchResult();
      this.services.userMenu.closeMenu();
      this.services.sideMenu.closeMobileMenu();
      this.props.searchSuggestion.executeAction();
      this.services.analytics.sendAnalytics('Search', this.props.searchSuggestion.type, this.props.searchSuggestion.text);
    };

    _renderSearchLinkBox(iconStyle: string) {
      switch(iconStyle) {
        case GAMES_CATEGORIES.SLOTS:
          return (
              <SlotsSearchLinkBox className={'cy-search-link-box-' + iconStyle}>
                <HighlightSearchListItemComponent gameName={this.props.searchSuggestion.text}/>
              </SlotsSearchLinkBox>
          );
        case GAMES_CATEGORIES.LIVE:
          return (
              <LiveSearchLinkBox className={'cy-search-link-box-' + iconStyle}>
                <HighlightSearchListItemComponent gameName={this.props.searchSuggestion.text}/>
              </LiveSearchLinkBox>
          );
        case GAMES_CATEGORIES.CARD_AND_TABLE:
          return (
              <CardAndTableSearchLinkBox className={'cy-search-link-box-' + iconStyle}>
                <HighlightSearchListItemComponent gameName={this.props.searchSuggestion.text}/>
              </CardAndTableSearchLinkBox>
          );

          default:
              return (
                  <RegularSearchLinkBox className={'cy-search-link-box-' + iconStyle}>
                      <HighlightSearchListItemComponent gameName={this.props.searchSuggestion.text}/>
                  </RegularSearchLinkBox>
              );
      }
    }

    render() {
      return (
        <SearchResultItemBox
            className={'cy-search-results-item-box-' + this.props.searchSuggestion.text}
            key={this.props.searchSuggestion.text}
            onClick={this._onClickHandler}>
          {this._renderSearchLinkBox(this.props.searchSuggestion.linkIconClass)}
        </SearchResultItemBox>
      );
    }
  }
);
